import { createSlice, PayloadAction } from "@reduxjs/toolkit";

type DefaultState = {
  currentTab: number;
  paymentTab: number;
};

const initialState: DefaultState = {
  currentTab: 1,
  paymentTab: 0,
};

export const NavigationSlice = createSlice({
  name: "navigation",
  initialState: initialState,
  reducers: {
    setAccountTab: (state, action: PayloadAction<number>) => {
      state.currentTab = action.payload;
    },
    setPaymentTab: (state, action: PayloadAction<number>) => {
      state.paymentTab = action.payload;
    },
  },
});

export default NavigationSlice.reducer;
export const { setAccountTab, setPaymentTab } = NavigationSlice.actions;
